// Whether the list should mark an entry, and why in one phrase.
//
// The card's job is to be worth tapping, not to reproduce the form. Naming every
// outstanding field turns a row into a paragraph and still leaves the driver
// opening the sheet to act, so it says which kind of problem it is and how much,
// and the detail lives where it can be fixed.
//
// Two kinds, and the distinction is the useful part. A broken rule is a value
// that contradicts something — an end date before a start, a malformed phone. An
// unanswered certification is a question only the driver can answer, which is how
// an entry a recruiter created arrives. Red for the first, amber for the second;
// an entry with both leads with the rule, because a contradiction is the more
// urgent thing.

import type { EntryAttention } from '../components/EntryCard'

import { missingCertifications, validateEntry } from './validation'
import type { EntryDraft, FieldName } from './validation'

export interface Attention {
  attention: EntryAttention
  note?: string
}

export const attentionFor = (
  draft: EntryDraft,
  nowMonth: number
): Attention => {
  const errors = validateEntry(draft, nowMonth)
  const missing = missingCertifications(draft)
  // Certifications are not broken, they are unasked; they have their own state
  const brokenRules = (Object.keys(errors) as FieldName[]).filter(
    (field) => !missing.includes(field)
  )

  if (brokenRules.length > 0) {
    return { attention: 'invalid', note: 'Validation errors' }
  }
  if (missing.length > 0) {
    return {
      attention: 'needsAnswers',
      note: `${missing.length} ${
        missing.length === 1 ? 'question needs' : 'questions need'
      } your answer`,
    }
  }
  return { attention: 'none' }
}
